
import React, { useState } from "react";

export const PresentCheckParts = ({
    checked,
    present, 
    onSelectPresent}) => {
    
    return (
        <div className="prizebox_check">
            <div className="f-checkbox">
                <input type="checkbox" 
                        name="prize" 
                        value={present.id} 
                        id={present.id} 
                        onChange={onSelectPresent} 
                        data-color={false}
                        checked={checked}
                        />
                <label htmlFor={present.id}>この賞品にする</label>
            </div>
        </div>
    )
}

export const PresentCheckSelectColorParts = ({
    checked,
    present, 
    onSelectPresent,
    defaultColor,
    register}) => {
    
    const [color, setColor] = useState(defaultColor)

    const onColorSelect = (event) => {
        const selectedValue = event.target.value;
        setColor(selectedValue)
    }

    
    return (
        <div className="prizebox_check">
            <div className="block4">
                <div className="block4_1">
                    <div className="f-select2">
                        <div className="select_desc">
                            { color ? color : `ドロップダウンからご希望の色を選択してください` }
                        </div>
                        <select name="prize_color" {...register('color')} onChange={onColorSelect}>
                            <option value="ホワイト">ホワイト</option>
                            <option value="サックス">サックス</option>
                            <option value="ブラック">ブラック</option>
                            <option value="ネイビー">ネイビー</option>
                            <option value="ベージュ×ホワイト">ベージュ×ホワイト</option>
                        </select>
                    </div>
                </div>
                <div className="block4_2">
                    <div className="f-checkbox">
                        <input type="checkbox" 
                                name="prize" 
                                value={present.id} 
                                id={present.id} 
                                onChange={onSelectPresent} 
                                data-color={true}
                                checked={checked}
                                />
                        <label htmlFor={present.id}>この賞品にする</label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const PresentGoodsParts = ({present}) => {
    return (
        <>
            <div className="prizebox_inner">
                <img src={`${process.env.REACT_APP_HOME_URL}/images/${present.id}.jpg`}
                     alt={present.name}/>
                <img src={`${process.env.REACT_APP_HOME_URL}/images/${present.num}.png`} 
                        className='prizebox_num'/>
            </div>
        </>
    )
}
